var map = {
	"./IMG_0986.jpeg": 5995,
	"./blue-jay.ab8bc7c1.jpg": 8593,
	"./columns.1bd8dee7.jpg": 6029,
	"./largeChurch.3917ab36.jpg": 8962
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 283;